module.exports = __webpack_public_path__ + "wxMicroService/img/img_pay_wait.3f0ad15b.png";